module.exports = __webpack_public_path__ + "img/836221.58a76de2.jpg";